import { render, staticRenderFns } from "./taxArrearsList.vue?vue&type=template&id=8b021b88&scoped=true"
import script from "./taxArrearsList.vue?vue&type=script&lang=js"
export * from "./taxArrearsList.vue?vue&type=script&lang=js"
import style0 from "./taxArrearsList.vue?vue&type=style&index=0&id=8b021b88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b021b88",
  null
  
)

export default component.exports